import { action, computed, observable } from "mobx";
import NestStore from "~/stores/NestStore";
import SubscriptionEventRepository from "~/repository/Subscription/SubscriptionEventRepository";
import SubscriptionEvent from "~/models/Subscription/SubscriptionEvent";

class SubscriptionEventStore extends NestStore {
  /**
   * @property {Array}
   */
  @observable subscriptionEvents = [];

  subscriptionEventRepository = null;

  constructor() {
    super();

    this.subscriptionEventRepository = new SubscriptionEventRepository();

    this.setDefaultSearchParams();
  }

  @action
  loadIndex() {
    this.isLoading = true;

    return Promise.all([this.getAll()]).finally(() => {
      this.isLoading = false;
    });
  }

  /**
   * Get all.
   */
  @action
  getAll() {
    const params = {};

    if (this.searchParams.month !== "") {
      params.month = this.searchParams.month;
    }

    if (this.searchParams.year !== "") {
      params.year = this.searchParams.year;
    }

    if (this.searchParams.subscriptionId !== "") {
      params.subscriptionId = this.searchParams.subscriptionId;
    }

    return this.subscriptionEventRepository.fetch(params).then(response => {
      this.processEntities(response.data.subscriptionEvents);
    });
  }

  @action
  processEntities(subscriptionEvents = []) {
    this.subscriptionEvents = [];

    subscriptionEvents.forEach(subscriptionEventArray => {
      const subscriptionEvent = new SubscriptionEvent(subscriptionEventArray);

      this.subscriptionEvents.push(subscriptionEvent);
    });
  }

  /**
   * Set default search params.
   */
  @action
  setDefaultSearchParams() {
    this.searchParams.month = "";
    this.searchParams.year = "";
    this.searchParams.subscriptionId = "";
  }

  @computed
  get monthlyRecurringRevenue() {
    let monthlyRecurringRevenue = 0;

    this.subscriptionEvents.forEach(subscriptionEvent => {
      if (subscriptionEvent.type === "creation" || subscriptionEvent.type === "billingCycle") {
        monthlyRecurringRevenue += subscriptionEvent.totalAmount;
      }
    });

    return monthlyRecurringRevenue;
  }
}

export default SubscriptionEventStore;
